import { useState } from 'react'
import useReportingPeriod from '../../../hooks/useReportingPeriod'

interface ReportingControls {
  // Original reporting period data
  dayOfMonthLimit: number
  pastDeadline: boolean
  currentMonth: boolean
  originalMonthMoment: moment.Moment
  isReady: boolean

  // User selection state
  selectedMonth: boolean | null
  setSelectedMonth: (value: boolean | null) => void

  // Calculated values based on selection
  effectiveCurrentMonth: boolean
  monthMoment: moment.Moment
  month: string
  changeToMoment: moment.Moment
}

export const useReportingControls = (): ReportingControls => {
  const {
    dayOfMonthLimit,
    pastDeadline,
    currentMonth,
    monthMoment: originalMonthMoment,
    isReady,
  } = useReportingPeriod()

  const [selectedMonth, setSelectedMonth] = useState<boolean | null>(null)

  // Use the value from the server, but allow user selection to override it
  const effectiveCurrentMonth =
    selectedMonth !== null ? selectedMonth : currentMonth

  // Recalculate moment objects based on the effective current month
  const monthMoment = originalMonthMoment
    .clone()
    .add(
      effectiveCurrentMonth !== currentMonth
        ? effectiveCurrentMonth
          ? 1
          : -1
        : 0,
      'months'
    )

  const month = monthMoment.format('YYYY-MM')
  const changeToMoment = monthMoment
    .clone()
    .add(effectiveCurrentMonth ? -1 : 1, 'month')

  return {
    dayOfMonthLimit,
    pastDeadline,
    currentMonth,
    originalMonthMoment,
    isReady,
    selectedMonth,
    setSelectedMonth,
    effectiveCurrentMonth,
    monthMoment,
    month,
    changeToMoment,
  }
}
